import { useQuery } from '@apollo/client'
import { Button } from 'components/atoms'
import { TEAM_SUBSCRIPTION_ANNUAL } from 'constants/subscription'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from 'theme'

import { SUBSCRIPTION } from '@/graphql/queries/user'

const CurrentSubscription = ({
  automaticRenewal,
  isOwner,
  licenceCount,
  platform,
  subscriptionName,
  onChange,
}) => {
  const { data } = useQuery(SUBSCRIPTION)
  const {
    plan,
  } = data.me.subscription

  const formattedSubscriptionName =
    subscriptionName === 'Liberté'
      ? `${subscriptionName} - Mensuel`
      : subscriptionName

  const formattedLicenceCount =
    licenceCount > 1 && isOwner
      ? `${licenceCount} licences`
      : null

  return (
    <Wrapper>
      <Top>
        <Title>
          MON ABONNEMENT
        </Title>
        {
          platform === 'stripe' && plan.id !== TEAM_SUBSCRIPTION_ANNUAL ? (
            <Button
              href="/me/upgrade"
              variant="tertiary"
            >
              Modifier mon abonnement
            </Button>
          )
            : null
        }
      </Top>

      { platform === 'api' ? (
        <LicenceDescription>
          Vous bénéficiez d&apos;un abonnement{' '}
          <strong>{formattedSubscriptionName}</strong>
          {formattedLicenceCount && ` de ${formattedLicenceCount}`}{' '}
          via notre partenaire <strong>Ma Formation Officinale</strong>.
          <br />
          Pour retrouver vos informations, connectez-vous sur{' '}
          <a
            href="https://www.maformationofficinale.com/connexion"
            target="_blank"
            rel="noreferrer"
          >
            maformationofficinale.com
          </a>{' '}
          dans votre espace.
          <br />
          Pour toute modification, vous pouvez contacter votre conseiller.
        </LicenceDescription>
      ) : (
        <LicenceDescription>
          Abonnement <strong>{ formattedSubscriptionName }</strong>
          { formattedLicenceCount && ` - ${formattedLicenceCount}` }
        </LicenceDescription>
      )}

      {
        isOwner ? (
          <AutomaticRenewal>
            {(
              function() {
                switch (platform) {
                  case 'stripe':
                    return (
                      <CancelButton disabled={ !automaticRenewal }
                        variant="primary"
                        onClick={ onChange }
                      >
                        { automaticRenewal ? 'Annuler mon abonnement' : 'Abonnement annulé' }
                      </CancelButton>
                    )
                  case 'apple':
                    return (
                      <CancelInstruction>Pour annuler votre abonnement, vous devez modifier vos paramètres d&apos;abonnement dans votre compte Apple Store</CancelInstruction>
                    )
                  case 'google':
                    return (
                      <CancelInstruction>Pour annuler votre abonnement, vous devez modifier vos paramètres d&apos;abonnement dans votre compte Google Play</CancelInstruction>
                    )
                  default:
                    return null
                }
              })()
            }
          </AutomaticRenewal>
        )
          : null
      }
    </Wrapper>
  )
}

CurrentSubscription.propTypes = {
  automaticRenewal: PropTypes.bool.isRequired,
  isOwner: PropTypes.bool.isRequired,
  licenceCount: PropTypes.number.isRequired,
  platform: PropTypes.string.isRequired,
  subscriptionName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Top = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: baseline;
  justify-content: space-between;
`

const Title = styled.span`
  font-family: Montserrat;
  font-size: 1rem;
  font-weight: 800;
  color: ${colors.midnightBlue};
`

const LicenceDescription = styled.p`
  font-family: 'brother-1816';
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: ${colors.midnightBlue};
`

const AutomaticRenewal = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
`

const CancelButton = styled(Button)`
  && {
    height: 0.4rem;
    font-size: 0.75rem;
    background-color: ${colors.pink};
    background-image: none;
    border-radius: 0;
    box-shadow: none;
  }
`

const CancelInstruction = styled.h3`
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: 'brother-1816';
  font-size: 1rem;
  font-style: normal;
  font-weight: normal;
  color: ${colors.darkGray};
`

export default CurrentSubscription
